module.exports = __webpack_public_path__ + "static/media/51-metre Dunia Baru.488ebec0.jpg";